import Wrapper from '@/components/base/Wrapper';
import MenuList from '@/components/menu/Menu';
import ClassSection from '@/components/menu/ClassSection';
import SuccessPage from '@/pages/Success';

const discussion = {
  path: 'discussion',
  component: Wrapper,
  meta: { breadCrumb: 'content.discussion' },
  children: [
    {
      path: '',
      name: 'DiscussionStudentIndexClass',
      component: () => import(/* webpackChunkName: "quiz-index" */ '@/pages/forum'),
      meta: { rule: 'isStudentTeacher', layout: 'default' },
      props: { isClass: true, isStudent: true }
    },
    {
      path: 'create',
      name: 'DiscussionStudentCreateClass',
      component: () => import(/* webpackChunkName: "quiz-form" */ '@/pages/forum/CreateEdit'),
      meta: { rule: 'isStudentTeacher', layout: 'default', breadCrumb: 'content.add_discussion' },
      props: { isClass: true, isStudent: true }
    },
    {
      path: 'edit/:id',
      component: Wrapper,
      meta: { breadCrumb: 'content.syllabus' },
      children: [
        {
          path: '',
          name: 'DiscussionStudentEditClass',
          component: () => import(/* webpackChunkName: "assignment" */ '@/pages/forum/CreateEdit'),
          meta: { rule: 'isStudentTeacher', layout: 'default' },
          props: { isClass: true, isStudent: true }
        }
      ]
    },
    {
      path: 'view/:id',
      component: Wrapper,
      meta: { breadCrumb: 'content.view_discussion' },
      children: [
        {
          path: '',
          name: 'DiscussionStudentViewClass',
          component: () => import(/* webpackChunkName: "assignment" */ '@/pages/forum/View'),
          meta: { rule: 'isStudentTeacher', layout: 'default' },
          props: { isClass: true, isStudent: true }
        }
      ]
    }
  ]
};

const syllabus = {
  path: 'syllabus',
  component: Wrapper,
  meta: { breadCrumb: 'content.syllabus' },
  children: [
    {
      path: '',
      name: 'SyllabusnStudentIndexClass',
      component: () => import(/* webpackChunkName: "quiz-index" */ '@/pages/syllabus/StudentView'),
      meta: { rule: 'isStudentTeacher', layout: 'default' },
      props: { isClass: true, isStudent: true }
    }
  ]
};

const pages = {
  path: 'pages',
  component: Wrapper,
  meta: { breadCrumb: 'content.pages' },
  children: [
    // {
    //   path: '',
    //   name: 'PagesStudentIndexClass',
    //   component: () => import(/* webpackChunkName: "quiz-index" */ '@/pages/page'),
    //   meta: { rule: 'isStudent', layout: 'default' },
    //   props: { isClass: true, isStudent: true }
    // },
    // {
    //   path: 'create',
    //   name: 'PagesStudentCreateClass',
    //   component: () => import(/* webpackChunkName: "quiz-form" */ '@/pages/page/CreateEdit'),
    //   meta: { rule: 'isStudent', layout: 'default', breadCrumb: 'content.add_discussion' },
    //   props: { isClass: true, isStudent: true }
    // },
    // {
    //   path: 'edit/:id',
    //   component: Wrapper,
    //   meta: { breadCrumb: 'content.syllabus' },
    //   children: [
    //     {
    //       path: '',
    //       name: 'PagesStudentEditClass',
    //       component: () => import(/* webpackChunkName: "assignment" */ '@/pages/page/CreateEdit'),
    //       meta: { rule: 'isStudent', layout: 'default' },
    //       props: { isClass: true, isEditable: false, isStudent: true }
    //     }
    //   ]
    // },
    {
      path: 'view/:id',
      component: Wrapper,
      children: [
        {
          path: '',
          name: 'PagesStudentViewClass',
          component: () => import(/* webpackChunkName: "assignment" */ '@/pages/page/StudentView'),
          meta: { rule: 'isStudent', layout: 'default', meta: 'content.view_pages' },
          props: { isClass: true, isEditable: true, isStudent: true }
        }
      ]
    }
  ]
};

const announcement = {
  path: 'announcement',
  component: Wrapper,
  meta: { breadCrumb: 'content.announcement' },
  children: [
    {
      path: '',
      name: 'AnnouncementStudentIndexClass',
      component: () => import(/* webpackChunkName: "quiz-index" */ '@/pages/announcement'),
      meta: { rule: 'isStudent', layout: 'default' },
      props: { isClass: true, isStudent: true }
    },
    {
      path: 'view/:id',
      component: Wrapper,
      meta: { breadCrumb: 'content.view_announcement' },
      children: [
        {
          path: '',
          name: 'AnnouncementStudentViewClass',
          component: () => import(/* webpackChunkName: "assignment" */ '@/pages/announcement/StudentView'),
          meta: { rule: 'isStudent', layout: 'default' },
          props: { isClass: true, isEditable: true, isStudent: true }
        }
      ]
    }
  ]
};

const modules = {
  path: 'modules',
  component: Wrapper,
  meta: { breadCrumb: 'content.modules' },
  children: [
    {
      path: '',
      name: 'ModulesStudentIndexClass',
      component: () => import(/* webpackChunkName: "quiz-index" */ '@/pages/modules'),
      meta: { rule: 'isStudent', layout: 'default' },
      props: { isClass: true, isStudent: true }
    }
  ]
};

const discussion_section = {
  path: 'discussion',
  component: Wrapper,
  meta: { breadCrumb: 'content.discussion' },
  children: [
    {
      path: '',
      name: 'DiscussionStudentSectionIndexClass',
      component: () => import(/* webpackChunkName: "quiz-index" */ '@/pages/forum'),
      meta: { rule: 'isStudentTeacher', layout: 'default' },
      props: { isClass: true, isStudent: true }
    },
    {
      path: 'create',
      name: 'DiscussionStudentSectionCreateClass',
      component: () => import(/* webpackChunkName: "quiz-form" */ '@/pages/forum/CreateEdit'),
      meta: { rule: 'isStudentTeacher', layout: 'default', breadCrumb: 'content.add_discussion' },
      props: { isClass: true, isStudent: true }
    },
    {
      path: 'edit/:id',
      component: Wrapper,
      meta: { breadCrumb: 'content.syllabus' },
      children: [
        {
          path: '',
          name: 'DiscussionStudentSectionEditClass',
          component: () => import(/* webpackChunkName: "assignment" */ '@/pages/forum/CreateEdit'),
          meta: { rule: 'isStudentTeacher', layout: 'default' },
          props: { isClass: true, isStudent: true }
        }
      ]
    },
    {
      path: 'view/:id',
      component: Wrapper,
      meta: { breadCrumb: 'content.view_discussion' },
      children: [
        {
          path: '',
          name: 'DiscussionStudentSectionViewClass',
          component: () => import(/* webpackChunkName: "assignment" */ '@/pages/forum/View'),
          meta: { rule: 'isStudentTeacher', layout: 'default' },
          props: { isClass: true, isStudent: true }
        }
      ]
    }
  ]
};

const syllabus_section = {
  path: 'syllabus',
  component: Wrapper,
  meta: { breadCrumb: 'content.syllabus' },
  children: [
    {
      path: '',
      name: 'SyllabusnStudentSectionIndexClass',
      component: () => import(/* webpackChunkName: "quiz-index" */ '@/pages/syllabus/StudentView'),
      meta: { rule: 'isStudentTeacher', layout: 'default' },
      props: { isClass: true, isStudent: true }
    }
  ]
};

const pages_section = {
  path: 'pages',
  component: Wrapper,
  meta: { breadCrumb: 'content.pages' },
  children: [
    {
      path: 'view/:id',
      component: Wrapper,
      children: [
        {
          path: '',
          name: 'PagesStudentSectionViewClass',
          component: () => import(/* webpackChunkName: "assignment" */ '@/pages/page/StudentView'),
          meta: { rule: 'isStudent', layout: 'default', meta: 'content.view_pages' },
          props: { isClass: true, isEditable: true, isStudent: true }
        }
      ]
    }
  ]
};

const announcement_section = {
  path: 'announcement',
  component: Wrapper,
  meta: { breadCrumb: 'content.announcement' },
  children: [
    {
      path: '',
      name: 'AnnouncementStudentSectionIndexClass',
      component: () => import(/* webpackChunkName: "quiz-index" */ '@/pages/announcement'),
      meta: { rule: 'isStudent', layout: 'default' },
      props: { isClass: true, isStudent: true }
    },
    {
      path: 'view/:id',
      component: Wrapper,
      meta: { breadCrumb: 'content.view_announcement' },
      children: [
        {
          path: '',
          name: 'AnnouncementStudentSectionViewClass',
          component: () => import(/* webpackChunkName: "assignment" */ '@/pages/announcement/StudentView'),
          meta: { rule: 'isStudent', layout: 'default' },
          props: { isClass: true, isEditable: true, isStudent: true }
        }
      ]
    }
  ]
};

const modules_section = {
  path: 'modules',
  component: Wrapper,
  meta: { breadCrumb: 'content.modules' },
  children: [
    {
      path: '',
      name: 'ModulesStudentSectionIndexClass',
      component: () => import(/* webpackChunkName: "quiz-index" */ '@/pages/modules'),
      meta: { rule: 'isStudent', layout: 'default' },
      props: { isClass: true, isStudent: true }
    }
  ]
};

export default [
  // Student :: Course
  {
    path: '/student-class',
    component: Wrapper,
    meta: { breadCrumb: 'content.class_list' },
    children: [
      {
        path: '',
        name: 'StudentClassIndex',
        component: () => import(/* webpackChunkName: "teacher-class" */ '@/components/menu/Class'),
        meta: { rule: 'isStudent', layout: 'default' },
        props: { type: 'student' }
      },
      {
        path: 'class/:classId',
        component: Wrapper,
        meta: { breadCrumb: 'content.class_title' },
        children: [
          {
            path: '',
            name: 'StudentCourseIndex',
            component: () => import(/* webpackChunkName: "teacher-course" */ '@/components/menu/Course'),
            meta: { rule: 'isStudent', layout: 'default' },
            props: { type: 'student' }
          },
          {
            path: 'erapor',
            component: Wrapper,
            meta: { breadCrumb: 'content.erapor' },
            children: [
              {
                path: '',
                name: 'EraporStudentView',
                component: () => import(/* webpackChunkName: "teacher-course" */ '@/pages/template_generator/Template'),
                meta: { rule: 'isStudent', layout: 'default' },
                props: { type: 'student', isEditable: false }
              }
            ]
          },
          /* class biasa */
          {
            path: 'course/:courseId',
            component: Wrapper,
            meta: { breadCrumb: 'table.menu' },
            children: [
              {
                path: '',
                name: 'StudentCourseList',
                component: MenuList,
                meta: { rule: 'isStudent', layout: 'default' },
                props: { type: 'student' }
              },
              announcement,
              modules,
              pages,
              syllabus,
              discussion,
              {
                path: 'attendance',
                name: 'StudentAttendance',
                component: () => import(/* webpackChunkName: "attendance" */ '@/pages/attendance'),
                meta: { rule: 'isStudent', layout: 'default', breadCrumb: 'menu.attendance' }
              },
              {
                path: 'score',
                name: 'StudentScore',
                component: () => import(/* webpackChunkName: "score" */ '@/pages/score'),
                meta: { rule: 'isStudent', layout: 'default', breadCrumb: 'menu.score' }
              },
              {
                path: 'file',
                name: 'StudentFile',
                component: () => import(/* webpackChunkName: "file" */ '@/pages/files'),
                meta: { rule: 'isStudent', layout: 'default', breadCrumb: 'menu.files' }
              },
              {
                path: 'assignment',
                component: Wrapper,
                meta: { breadCrumb: 'menu.assignment' },
                children: [
                  {
                    path: '',
                    name: 'StudentAssignment',
                    component: () => import(/* webpackChunkName: "assignment" */ '@/pages/assignment'),
                    meta: { rule: 'isStudent', layout: 'default' }
                  },
                  {
                    path: ':assignmentId/detail',
                    component: Wrapper,
                    meta: { breadCrumb: 'content.assignment_detail' },
                    children: [
                      {
                        path: '',
                        name: 'StudentAssignmentDetail',
                        component: () => import(/* webpackChunkName: "assignment" */ '@/pages/assignment/detail'),
                        meta: { rule: 'isStudent', layout: 'default' }
                      },
                      {
                        path: 'quizStudent',
                        name: 'StudentAssignmentScoreQuiz',
                        component: () => import(/* webpackChunkName: "assignment" */ '@/pages/assignment/QuizStudent'),
                        meta: { rule: 'isStudent', layout: 'default', breadCrumb: 'menu.quiz' }
                      },
                      {
                        path: 'success',
                        name: 'StudentAssignmentScoreQuizSuccess',
                        component: SuccessPage,
                        meta: { rule: 'isStudent' },
                        props: { type: 'assign-student-quiz' }
                      },
                      {
                        path: 'success',
                        name: 'StudentAssignmentScoreQuizSuccessModules',
                        component: SuccessPage,
                        meta: { rule: 'isStudent' },
                        props: { type: 'assign-student-quiz-modules' }
                      },
                      {
                        path: ':submissionId/detailquiz',
                        component: Wrapper,
                        meta: { breadCrumb: 'content.assignment_detail_quiz' },
                        children: [
                          {
                            path: '',
                            name: 'StudentAssignmentDetailQuiz',
                            component: () => import(/* webpackChunkName: "assignment" */ '@/pages/assignment/ViewQuiz'),
                            meta: { rule: 'isStudent', layout: 'default' }
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          /* section class */
          {
            path: 'course/:courseId/sectionclass',
            component: Wrapper,
            meta: { breadCrumb: 'content.class_section' },
            children: [
              {
                path: '',
                name: 'StudentClassSectionList',
                component: ClassSection,
                meta: { rule: 'isStudent', layout: 'default' },
                props: { type: 'student' }
              },
              {
                path: ':classSectionId',
                component: Wrapper,
                meta: { breadCrumb: 'table.menu' },
                children: [
                  {
                    path: '',
                    name: 'StudentMenuSectionList',
                    component: MenuList,
                    meta: { rule: 'isStudent', layout: 'default' },
                    props: { type: 'student' }
                  },
                  announcement_section,
                  modules_section,
                  pages_section,
                  syllabus_section,
                  discussion_section,
                  {
                    path: 'attendance',
                    name: 'StudentSectionAttendance',
                    component: () => import(/* webpackChunkName: "attendance" */ '@/pages/attendance'),
                    meta: { rule: 'isStudent', layout: 'default', breadCrumb: 'menu.attendance' }
                  },
                  {
                    path: 'score',
                    name: 'StudentSectionScore',
                    component: () => import(/* webpackChunkName: "score" */ '@/pages/score'),
                    meta: { rule: 'isStudent', layout: 'default', breadCrumb: 'menu.score' }
                  },
                  {
                    path: 'file',
                    name: 'StudentSectionFile',
                    component: () => import(/* webpackChunkName: "file" */ '@/pages/files'),
                    meta: { rule: 'isStudent', layout: 'default', breadCrumb: 'menu.files' }
                  },
                  {
                    path: 'assignment',
                    component: Wrapper,
                    meta: { breadCrumb: 'menu.assignment' },
                    children: [
                      {
                        path: '',
                        name: 'StudentSectionAssignment',
                        component: () => import(/* webpackChunkName: "assignment" */ '@/pages/assignment'),
                        meta: { rule: 'isStudent', layout: 'default' }
                      },
                      {
                        path: ':assignmentId/detail',
                        component: Wrapper,
                        meta: { breadCrumb: 'content.assignment_detail' },
                        children: [
                          {
                            path: '',
                            name: 'StudentSectionAssignmentDetail',
                            component: () => import(/* webpackChunkName: "assignment" */ '@/pages/assignment/detail'),
                            meta: { rule: 'isStudent', layout: 'default' }
                          },
                          {
                            path: 'quizStudent',
                            name: 'StudentSectionAssignmentScoreQuiz',
                            component: () => import(/* webpackChunkName: "assignment" */ '@/pages/assignment/QuizStudent'),
                            meta: { rule: 'isStudent', layout: 'default', breadCrumb: 'menu.quiz' }
                          },
                          {
                            path: 'success',
                            name: 'StudentSectionAssignmentScoreQuizSuccess',
                            component: SuccessPage,
                            meta: { rule: 'isStudent' },
                            props: { type: 'assign-section-student-quiz' }
                          },
                          {
                            path: 'success',
                            name: 'StudentSectionAssignmentScoreQuizSuccessModules',
                            component: SuccessPage,
                            meta: { rule: 'isStudent' },
                            props: { type: 'assign-section-student-quiz-modules' }
                          },
                          {
                            path: ':submissionId/detailquiz',
                            component: Wrapper,
                            meta: { breadCrumb: 'content.assignment_detail_quiz' },
                            children: [
                              {
                                path: '',
                                name: 'StudentSectionAssignmentDetailQuiz',
                                component: () => import(/* webpackChunkName: "assignment" */ '@/pages/assignment/ViewQuiz'),
                                meta: { rule: 'isStudent', layout: 'default' }
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },

  // {
  //   path: '/course-student',
  //   component: Wrapper,
  //   meta: { breadCrumb: 'content.course_list' },
  //   children: [
  //     {
  //       path: '',
  //       name: 'StudentCourseIndex',
  //       component: () => import(/* webpackChunkName: "course-list" */ '@/components/menu/Course'),
  //       meta: { rule: 'isStudent', layout: 'default' },
  //       props: { type: 'student' }
  //     },
  //     {
  //       path: 'course/:courseId',
  //       component: Wrapper,
  //       meta: { breadCrumb: 'Biology' },
  //       children: [
  //         {
  //           path: '',
  //           name: 'StudentCourseList',
  //           component: MenuList,
  //           meta: { rule: 'isStudent', layout: 'default' },
  //           props: { type: 'student' }
  //         },
  //         {
  //           path: 'attendance',
  //           name: 'StudentAttendance',
  //           component: () => import(/* webpackChunkName: "attendance" */ '@/pages/attendance'),
  //           meta: { rule: 'isStudent', layout: 'default', breadCrumb: 'menu.attendance' }
  //         },
  //         {
  //           path: 'score',
  //           name: 'StudentScore',
  //           component: () => import(/* webpackChunkName: "score" */ '@/pages/score'),
  //           meta: { rule: 'isStudent', layout: 'default', breadCrumb: 'menu.score' }
  //         },
  //         {
  //           path: 'file',
  //           name: 'StudentFile',
  //           component: () => import(/* webpackChunkName: "file" */ '@/pages/files'),
  //           meta: { rule: 'isStudent', layout: 'default', breadCrumb: 'menu.file' }
  //         },
  //         {
  //           path: 'assignment',
  //           component: Wrapper,
  //           meta: { breadCrumb: 'menu.assignment' },
  //           children: [
  //             {
  //               path: '',
  //               name: 'StudentAssignment',
  //               component: () => import(/* webpackChunkName: "assignment" */ '@/pages/assignment'),
  //               meta: { rule: 'isStudent', layout: 'default' }
  //             },
  //             {
  //               path: ':assignmentId/detail',
  //               name: 'StudentAssignmentDetail',
  //               component: () => import(/* webpackChunkName: "assignment" */ '@/pages/assignment/detail'),
  //               meta: { rule: 'isStudent', layout: 'default', breadCrumb: 'menu.assignment' }
  //             }
  //           ]
  //         }
  //       ]
  //     }
  //   ]
  // },

  // Schedule (Student & Parent)
  {
    path: '/schedule',
    name: 'Schedule',
    component: () => import(/* webpackChunkName: "schedule-index" */ '@/pages/schedule'),
    meta: { rule: 'isStudentParent', layout: 'default', breadCrumb: 'menu.schedule' }
  }
];
